export default import.meta.ROLLDOWN_FILE_URL_QSQ_WkHTSy9aO4fri9FIrA